import api from '../../api'
import {
  GET_AGREEMENT_LIST_SUCCESS,
  GET_AGREEMENT_LIST_FAILURE,
  GET_AGREEMENT_FAILURE, 
  GET_AGREEMENT_SUCCESS,
  UPDATE_AGREEMENT_SUCCESS,
} from '../types'

const state = {
  list: [],
  listUpdated: (new Date()),
  toValidateList: [],
  selected: null,
  selectedUpdated: (new Date())
};


const actions = {

  
  getAgreementList({commit}, query) {
    return new Promise((resolve, reject) => {

    api.startLoader()
    api.getAgreementList(query).then(response => {
      if (!response.ok) {
        api.stopLoader()
         commit(GET_AGREEMENT_LIST_FAILURE)
         return reject(response.body.$error)

      }
      commit(GET_AGREEMENT_LIST_SUCCESS, {
        agreementList: response.body.data
      })
      api.stopLoader()
      return resolve(response.body.data)

    }, response => {
      api.stopLoader()
      commit(GET_AGREEMENT_LIST_FAILURE)
      return reject(response.body.$error)

    })
  })
  },
 
  cleanAgreementList({commit}) {
    return commit(GET_AGREEMENT_LIST_FAILURE)
  },
  
  getAgreement({commit}, ud) {
    return new Promise((resolve, reject) => {

      api.getAgreement(ud)
        .then(response => {
          console.log(response);
          if (!response.ok) {
            commit(GET_AGREEMENT_FAILURE);
            reject();
          }
          commit(GET_AGREEMENT_SUCCESS, {
            agreement: response.body
          });
          resolve(response.body);
        }, response => {
          commit(GET_AGREEMENT_FAILURE);
          reject();
        })
    })
  },
 
  
  updateAgreement({commit}, data) {
    return new Promise((resolve, reject) => {

      api.startLoader()

      if (data.formattedPhone != undefined) {
        data.phone = data.formattedPhone.replace(/[^0-9]/g, '');
      }

      let avaliables = [
        "id",
        "title",
        "subtitle",
        "description",
        "site",
        "phone",
        "address_street",
        "address_number",
        "address_district",
        "address_city",
        "address_state",
        "address_abbreviation",
        "address_cep",
        "address_complement"
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

          api.updateAgreement(obj)
            .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
      
    })
  },
  createAgreement({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()

      if (data.formattedPhone != undefined) {
        data.phone = data.formattedPhone.replace(/[^0-9]/g, '');
      }

      api.createAgreement(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },
  
  
 
  deleteAgreement({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteAgreement(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },

  
  
};

const mutations = {

  [UPDATE_AGREEMENT_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.agreement));
  },
  [GET_AGREEMENT_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_AGREEMENT_LIST_SUCCESS](state, action) {
    state.list = action.agreementList;
    state.listUpdated = new Date();
  },
  [GET_AGREEMENT_FAILURE](state) {
    state.selected = null
  },
  [GET_AGREEMENT_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.agreement));
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/agreement.js